module.exports = __webpack_public_path__ + "img/10-12.0448c6c7.jpg";